// import { ProGalleryOptions } from './gallery.types';
import { optionsMap, galleryOptions, isInPreset, addPresetOptions, extendNestedOptionsToIncludeOldAndNew, } from 'pro-gallery-lib';
import optionsConverter from './proGalleryOptionsBuilder';
import { PRIVATE_CONTROLLERS } from './common/private-controllers';
var _isRelevant = function (paramName, settingOptions, enumOption) {
    var _a;
    var _b, _c;
    if (settingOptions === void 0) { settingOptions = {}; }
    var newSettingsOptions = optionsConverter(settingOptions).galleryOptions;
    var migratedOptions = extendNestedOptionsToIncludeOldAndNew(newSettingsOptions);
    var options = addPresetOptions(migratedOptions);
    var galleryLayout = options.galleryLayout;
    var settingsOptions = (_a = {},
        _a[optionsMap.layoutParams.navigationArrows.verticalAlignment] = {
            isRelevant: function () { return false; },
        },
        _a[optionsMap.behaviourParams.item.content.placementAnimation] = {
            isRelevant: function () { return false; },
        },
        _a[PRIVATE_CONTROLLERS.INFO.ALLOW_TITLE] = {
            isRelevant: function () { return true; },
        },
        _a[PRIVATE_CONTROLLERS.INFO.ALLOW_DESCRIPTION] = {
            isRelevant: function () { return true; },
        },
        _a[PRIVATE_CONTROLLERS.INFO.VERTICAL_PADDING] = {
            isRelevant: function (_opts) { return true; },
        },
        _a[PRIVATE_CONTROLLERS.INFO.HORIZONTAL_PADDING] = {
            isRelevant: function (_opts) { return true; },
        },
        _a[PRIVATE_CONTROLLERS.INFO.VERTICAL_ALIGN] = {
            isRelevant: function (_opts) { return true; },
        },
        _a[PRIVATE_CONTROLLERS.INFO.HORIZONTAL_ALIGN] = {
            isRelevant: function (_opts) { return true; },
        },
        _a[PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PIXEL] = {
            isRelevant: function (opts) {
                var unit = opts.layoutParams.info.sizeUnits;
                return (galleryOptions[optionsMap.layoutParams.info.width].isRelevant(opts) &&
                    unit === 'PIXEL');
            },
        },
        _a[PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PERCENT] = {
            isRelevant: function (opts) {
                var unit = opts.layoutParams.info.sizeUnits;
                return (galleryOptions[optionsMap.layoutParams.info.width].isRelevant(opts) &&
                    unit === 'PERCENT');
            },
        },
        _a.OVERLAY = {
            isRelevant: function (opts) {
                return galleryOptions[optionsMap.behaviourParams.item.overlay.size].isRelevant(opts);
            },
        },
        _a[PRIVATE_CONTROLLERS.OVERLAY.OVERLAY_TYPE] = {
            isRelevant: function (opts) {
                return galleryOptions[optionsMap.behaviourParams.item.overlay.size].isRelevant(opts);
            },
        },
        _a[optionsMap.behaviourParams.item.overlay.sizeUnits] = {
            isRelevant: function (opts) {
                var type = opts.controllers.behaviourParams.item.overlay.overlayType;
                return (galleryOptions[optionsMap.behaviourParams.item.overlay.sizeUnits].isRelevant(opts) && type === 'PARTIAL');
            },
        },
        _a[PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PERCENT] = {
            isRelevant: function (opts) {
                var unit = opts.behaviourParams.item.overlay.sizeUnits;
                var type = opts.controllers.behaviourParams.item.overlay.overlayType;
                return (galleryOptions[optionsMap.behaviourParams.item.overlay.sizeUnits].isRelevant(opts) &&
                    unit === 'PERCENT' &&
                    type === 'PARTIAL');
            },
        },
        _a[PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PIXEL] = {
            isRelevant: function (opts) {
                var unit = opts.behaviourParams.item.overlay.sizeUnits;
                var type = opts.controllers.behaviourParams.item.overlay.overlayType;
                return (galleryOptions[optionsMap.behaviourParams.item.overlay.sizeUnits].isRelevant(opts) &&
                    unit === 'PIXEL' &&
                    type === 'PARTIAL');
            },
        },
        _a[optionsMap.behaviourParams.item.overlay.position] = {
            isRelevant: function (opts) {
                var type = opts.controllers.behaviourParams.item.overlay.overlayType;
                return (galleryOptions[optionsMap.behaviourParams.item.overlay.position].isRelevant(opts) && type === 'PARTIAL');
            },
        },
        _a[optionsMap.behaviourParams.item.overlay.padding] = {
            isRelevant: function (opts) {
                var type = opts.controllers.behaviourParams.item.overlay.overlayType;
                return (galleryOptions[optionsMap.behaviourParams.item.overlay.padding].isRelevant(opts) && type === 'PARTIAL');
            },
        },
        _a);
    var isRelevantFunc = ((_b = settingsOptions === null || settingsOptions === void 0 ? void 0 : settingsOptions[paramName]) === null || _b === void 0 ? void 0 : _b.isRelevant) || ((_c = galleryOptions[paramName]) === null || _c === void 0 ? void 0 : _c.isRelevant);
    var isRelevant = !!isRelevantFunc && isRelevantFunc(options, enumOption);
    if (paramName === optionsMap.layoutParams.structure.galleryLayout) {
        return true; // for some reason the galleryLayout param appear on each preset
    }
    else if (isInPreset(galleryLayout, paramName)) {
        return false;
    }
    else {
        return isRelevant;
    }
};
export default _isRelevant;
//# sourceMappingURL=isRelevant.js.map